module.exports = __webpack_public_path__ + "img/art_6_3.21a5c99c.jpeg";